module.exports = __webpack_public_path__ + "img/group-161@2x.dc0fe481.png";